import React, { useRef, useState } from 'react';
import PropTypes from 'prop-types';

import { toBase64 } from 'shared/lib/lib/base64';
import { Spin } from 'shared';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faUser } from '@fortawesome/free-solid-svg-icons';
import Localize from 'components/Localize';
import LetterAvatar from 'components/ui/LetterAvatar';
import {
  AvatarWrapper,
  Avatar,
  AvatarUploadingOverlay,
  TooltipStyled,
} from './UserAvatarUploaderStyled';

const UserAvatarUploader = ({
  userFirstName,
  userLastName,
  isEditable,
  avatar,
  meta,
  onAvatarUpload,
}) => {
  const fileInputRef = useRef();
  const [isUploading, setIsUploading] = useState(false);
  const onOpenUploadWindow = () => {
    if (!isEditable || isUploading) return;
    fileInputRef.current.click();
  };
  const handleAvatarUpload = (e) => {
    const value = e.target.files[0];
    if (!value) return;
    setIsUploading(true);
    const stopUploading = () => setIsUploading(false);
    toBase64(value)
      .then(({ base64 }) => {
        // onAvatarUpload (Modal-Pfad) ist async -> Promise.resolve haelt den
        // Spinner bis der ECHTE Upload durch ist; im meta-Pfad bis toBase64.
        if (onAvatarUpload) {
          return Promise.resolve(onAvatarUpload(base64));
        }
        return meta.setFieldValue('avatar', base64);
      })
      // .then(fn, fn) statt .finally (kein ES2018-Polyfill noetig): reset bei
      // Erfolg UND Fehler.
      .then(stopUploading, stopUploading);
  };
  const avatarInhalt = (
    <Avatar className="avatar-wrap" onClick={onOpenUploadWindow}>
      {avatar ? (
        <img src={avatar} alt="user avatar" />
      ) : (
        <>
          <LetterAvatar bg="secondaryLight" fontSize={55} absolute>
            {' '}
            {userFirstName && userFirstName[0]}
            {userLastName && userLastName[0]}
          </LetterAvatar>
          {!userFirstName && !userLastName && (
            <FontAwesomeIcon
              className="avatar"
              size="sm"
              icon={faUser}
            />
          )}
        </>
      )}
      {isUploading && (
        <AvatarUploadingOverlay data-testid="avatar-uploading">
          <Spin />
        </AvatarUploadingOverlay>
      )}
    </Avatar>
  );

  return (
    <AvatarWrapper>
      {/* 🔴 Den Tooltip nur im Bearbeitungsmodus ueberhaupt MOUNTEN, nicht bloss
          mit open={false} verstecken. react-tippy haengt sein Element an
          document.body und raeumt es beim Unmount nicht ab: der Knoten blieb
          liegen, wenn die Einstellungsseite verschwand. Sichtbar wurde das erst
          durch den Kopfbereich auf dem Countdown-Bildschirm (09.08.) -- der
          verschiebt das Layout um die Kopfzeilenhoehe, und der absolut
          positionierte Rest landete mitten im Text statt unten ausserhalb.
          Am sichtbaren Verhalten aendert sich nichts: bei isEditable={false}
          war der Tooltip ohnehin geschlossen. */}
      {isEditable ? (
        <Localize>
          {({ translate }) => (
            <TooltipStyled
              title={translate('click-avatar-change-it')}
              theme="light"
              arrow
              open
              position="top-center"
            >
              {avatarInhalt}
            </TooltipStyled>
          )}
        </Localize>
      ) : avatarInhalt}
      <input
        className="avatar-input"
        name="avatar"
        type="file"
        accept="image/*"
        ref={fileInputRef}
        onChange={handleAvatarUpload}
      />
    </AvatarWrapper>
  );
};

UserAvatarUploader.propTypes = {
  isEditable: PropTypes.bool,
  userFirstName: PropTypes.string,
  userLastName: PropTypes.string,
  onAvatarUpload: PropTypes.func,
  avatar: PropTypes.string,
  meta: PropTypes.shape({
    setFieldValue: PropTypes.func.isRequired,
  }),
};

UserAvatarUploader.defaultProps = {
  isEditable: false,
  userFirstName: null,
  userLastName: null,
  avatar: null,
  meta: null,
  onAvatarUpload: null,
};

export default UserAvatarUploader;
